/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const ContactSection = ({ blok, getComponent }: PageProps) => {
  const contacts = blok.contact_list;
  const hasContacts = contacts?.length > 0;

  if (!hasContacts) return <></>;

  const headline = {
    _uid: `${blok._uid}-contact-headline`,
    component: 'roche-headline',
    headline: 'Kontaktieren Sie uns',
    level: 2,
  };

  return <>
    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-contact-headline-grid`,
        component: 'roche-grid-12',
        slotted: [headline],
      },
      getComponent,
    })}

    {blokToComponent({
      blok: {
        _uid: `${blok._uid}-contacts-grid`,
        component: 'roche-grid-6-6',
        remove_padding_top: true,
        slotted_left: hasContacts ? [contacts[0]] : [],
        slotted_right: contacts?.length > 1 ? [contacts[1]] : [],
      },
      getComponent,
    })}
  </>;
};
